import { Injectable } from '@angular/core';

import { GraphEndpoint } from '@camelot/server';

import { CamQuotationsService } from './quotations.service';

const graphEndpoint: GraphEndpoint = {
  clientName: 'quotationVisitorService',
  endpoint: 'quotation',
};

@Injectable({
  providedIn: 'root',
})
export class CamQuotationsVisitorService extends CamQuotationsService {
  protected override _graphEndpoint = graphEndpoint;

  constructor() {
    super();

    super.registerRoutes({ graphEndpoint });
  }
}
